import React, { useState, ReactNode } from "react";
import "@companion-core/web/src/Assets/Styles/scss/tooltip.scss";

interface TooltipProps {
  text: string;
  children: ReactNode;
  direction: "top" | "bottom" | "left" | "right";
  timer: number;
}

export const Tooltip = ({ text, children, direction, timer }: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const tooltipOn = () => {
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, timer);
  };

  return (
    <div className="tooltip" onClick={tooltipOn}>
      {showTooltip && (
        <div
          className={`tooltip__text ${direction ? `tooltip__text--${direction}` : ""}`}
          data-placement={direction}
          role="tooltip">
          {text}
        </div>
      )}
      {children}
    </div>
  );
};
